var vms = vms || {};
vms.log = vms.log || {};
vms.logTemp = vms.logTemp || {};
/* ------------ */
/* Log Template */
/* ------------ */
var logTemplate;
var taskParam;
var uomLov;
var chapterDeleteIds = [];
var chapterItemsDeleteIds = [];
var vNewChapterIds = 0;
vms.logTemp = {
	headerChange: false,
	render: function () {
		var $c = $(".logTemp");
		var vChapters = "";
		// no template data defined
		if (!logTemplate) return;

		for (i = 0; i < logTemplate.chapters.length; i++) {
			vChapters += this.retChapter(logTemplate.chapters[i], true);
		}
		vChapters = '<div class="lcForm">'+ vChapters +'</div><div class="lciForm" style="display:none;"></div>';
		$c.html(vChapters).change(function() {
			vms.btn.hightlight("submitChaptersBtn");
		  });
	},
	showHideSub: function (pThis) {
		var $btn = $(pThis);
		if ($btn.hasClass("expanded")) {
			$btn.closest('.chapter.main').find('.subChapters').hide();
			$btn.removeClass("expanded fawe-chevron-circle-down").addClass('fawe-chevron-circle-right');
		} else {
			$btn.closest('.chapter.main').find('.subChapters').show();
			$btn.removeClass('fawe-chevron-circle-right').addClass("expanded fawe-chevron-circle-down");
		}

	},
	toggleChapterType: function (pThis) {
		var $row = $(pThis).closest(".chapter");
		var oldVal = $row.attr('ctype');
		if (oldVal == 'N') {
			$row.attr('ctype', 'M');
			$(pThis).addClass('cTypeM');
		} else {
			$row.attr('ctype', 'N');
			$(pThis).removeClass('cTypeM');
		}
		vms.btn.hightlight("submitChaptersBtn");
	},
	delChapter: function (pThis) {
		if(confirm('Are you sure you want to delete this chapter?')){
			$c = $(pThis).closest(".chapter");
			chapterDeleteIds.push($c.attr("lcid"));
			$c.remove();
			$(".lciForm").hide();
			vms.btn.hightlight("submitChaptersBtn");
		}
	},
	retChapter: function (data, pMaster){
		if (pMaster) {
			var vRet = "";
			if (data.sub) {
				for (j = 0; j < data.sub.length; j++) {
					vRet += this.retChapter(data.sub[j]);
				}
			}
			return '<div class="chapter main" lcid="' + data.id + '"><div class="hdr">'
				+ '<div class="lcBtn showHideSub expanded fas fawe-chevron-circle-down" onclick="vms.logTemp.showHideSub(this);"></div>'
				+ '<div class="lcBtn sort">'
				+  '<div class="far fawe-chevron-up" onclick="vms.logTemp.chapterSort(this,\'UP\');"></div>'
				+  '<div class="far fawe-chevron-down" onclick="vms.logTemp.chapterSort(this,\'DOWN\');"></div>'
				+ '</div>'
				+ '<input name="name" type="text" value="'+ data.name +'" />'
				+ '<div class="lcBtn add far fawe-plus" onclick="vms.logTemp.addChapter(this);"></div>'
				+ '<div class="lcBtn delete fas fawe-trash-alt" onclick="vms.logTemp.delChapter(this);"></div>'
				+ '</div><div class="subChapters">'
				+ vRet
				+ '</div></div>';
		} else {
			return '<div class="chapter sub" lcid="' + data.id + '" ctype="'+ data.type +'">'
				+ '<div class="lcBtn sort">'
				+  '<div class="far fawe-chevron-up" onclick="vms.logTemp.chapterSort(this,\'UP\');"></div>'
				+  '<div class="far fawe-chevron-down" onclick="vms.logTemp.chapterSort(this,\'DOWN\');"></div>'
				+ '</div>'
				+ '<input name="name" type="text" value="'+ data.name +'" />'
				+ '<div class="lcBtn cType' + (data.type == 'N' ? '' : ' cTypeM') + '" onclick="vms.logTemp.toggleChapterType(this);" title="Multirow">M</div>'
				+ '<div class="lcBtn fields far fawe-ellipsis-h" onclick="vms.logTemp.chapterItems(this);"></div>'
				+ '<div class="lcBtn delete fas fawe-trash-alt" onclick="vms.logTemp.delChapter(this);"></div>'
				+ '</div>';
		}
	},
	addChapter: function (pThis, pMaster) {
		vNewChapterIds--;
		var vRow = this.retChapter({id: vNewChapterIds, name: "", type: "N"}, pMaster);
		if (pMaster) {
			$(".lcForm").append(vRow);
		} else {
			$(pThis).closest(".chapter").find(".subChapters").append( vRow );
		}
		$(".lciForm").hide();
		vms.btn.hightlight("submitChaptersBtn");
	},
	chapterSort: function (pThis, pDir){
		var $chapter = $(pThis).closest('.chapter');
		if (pDir == 'UP') $chapter.prev().before($chapter);
		else if (pDir == 'DOWN') $chapter.next().after($chapter);
		vms.btn.hightlight("submitChaptersBtn");
	},
	chapterItemsClose: function () {
		$(".lciForm").hide();
		$(".lcForm,#addChapter").show();
		$(".chapter.selected")[0].scrollIntoView({block: "center"});
	},
	chapterItems: function (pThis) {
		vms.logTemp.chapterItemsApply();
		var $chapter = $(pThis).closest(".chapter");
		var vChapterType = $chapter.attr("ctype");
		var vLcId = $chapter.attr("lcid");
		var vRows, vRowCnt = 0;
		$(".chapter.selected").removeClass("selected");
		$(".lciForm").html('<div class="hdr"><input id="lciLtId" type="hidden" value="' + vLcId
			+ '" /><input id="lciLtType" type="hidden" value="' + vChapterType + '" />'
			+ 'Selected Chapter: '+ $chapter.find("input[name=name]").val()
			+ '<div class="lciHdrBtns">'
			+ vms.btn.gen({"label":"Add Row","fa":"far fawe-plus","js":"vms.logTemp.lcAddItem();"})
			+ vms.btn.gen({"label":"Back","fa":"fas fawe-arrow-left","js":"vms.logTemp.chapterItemsClose();"})
			//+ '<div class="lcHdrBtn" onclick="vms.logTemp.lcAddItem();">ADD ROW</div>'
			//+ '<div class="lcHdrBtn" onclick="vms.logTemp.chapterItemsClose();">CLOSE</div>'
			+ '</div></div>'
			+ '<table>'
			+ '<thead><tr>'
			+ '<th></th>'
			+ '<th>No.</th>'
			+ '<th>Log Entry Name</th>'
			+ '<th style="width:15rem;">Item Type</th>'
			+ '<th>Input Type'/*+ (logTemplate.type == 'E' ? ' / Equipment Parameter' : '')*/ +'</th>'
			//+ (vChapterType == 'N' ? '<th style="width: 90px;">Frequency</th>' : '')
			+ '<th style="width:8rem;">Required Readings</th><th></th></tr></thead><tbody></tbody></table>').show();
		console.log('logTemplate.items.length=' + logTemplate.items.length);
		for (i = 0; i < logTemplate.items.length; i++) {
			if (logTemplate.items[i].lt_id == vLcId) {
				vms.logTemp.lcAddItem(logTemplate.items[i]);
				console.log(logTemplate.items[i].seq + "-" + logTemplate.items[i].lt_id + "-" + vLcId);
				vRowCnt++;
			}
		}
		$(pThis).closest(".chapter").addClass("selected");
		$(".lcForm,#addChapter").hide();
		if (vRowCnt == 0) vms.logTemp.lcAddItem();
	},
	chapterItemsApply: function () {
		var vFirst, vCnt = 0, vSeq = 0;
		var vLcId = $v("lciLtId");
		if (!vLcId) return;
		for (i = 0; i < logTemplate.items.length; i++) {
			if (logTemplate.items[i].lt_id == vLcId) {
				vCnt++;
				if (vCnt == 1) {
					vFirst = i;
					vSeq = logTemplate.items[i].seq;
				}
			}
		}
		//console.log(vSeq);
		if (vCnt > 0) logTemplate.items.splice(vFirst, vCnt);
		//vCnt = 0;
		//vSeq = 0;
		$(".lciForm > table > tbody > tr").each(function () {
			if ($(this).find("input[name=lciName]").val() != "")
				logTemplate.items.push({
					"id": $(this).find("input[name=lciId]").val()
					, "lt_id": vLcId
					, "seq": vSeq//vCnt
					, "name": $(this).find("input[name=lciName]").val().replace("|", "").replace("~", "")
					, "iType": $(this).find("select[name=lciItemType]").val().replace("|", "").replace("~", "")
					, "ips_id": $(this).find("input[name=lciIps]").val().replace("|", "").replace("~", "")
					, "ips_txt": $(this).find("input[name=lciIpsTxt]").val()
					, "rNrs": $(this).find("input[name=lciRNrs]").val().replace("|", "").replace("~", "")
					, "uom": $(this).find("select[name=lciUom]").val()
					, "sur": $(this).find("select[name=lciSur]").val()
				});
			vSeq++;
		});
	},
	lcAddItem: function (pData) {
		var vRow, vId = 0, vName = "", vIpsId = "", vIpsTxt = "", vRNrs = "1", vItemType = "N", vUom = "", vSeq = "", vSur = "";
		var lciLtType = $v("lciLtType");
		if (pData) {
			vId = pData.id;
			vName = pData.name;
			vIpsId = pData.ips_id;
			vIpsTxt = pData.ips_txt;
			vRNrs = pData.rNrs;
			vType = pData.type;
			vItemType = pData.iType;
			vUom = pData.uom;
			vSeq = pData.seq;
			vSur = pData.sur;
		}
		var vUomLov = "";
		for (let i = 0; i < uomLov.length; i++) {
			vUomLov += '<option value="'+ uomLov[i].r +'"'+ (uomLov[i].r == vUom ? ' selected' : '') +'>'+ uomLov[i].d +'</option>';
		}
		vUomLov = '<select name="lciUom" class="apex-item-select" size="1"'+ (vItemType == 'N' ? '' : ' style="display:none;"') +'><option value=""></option>'+ vUomLov +'</select>';
		// Survey Lov
		var vSurLov = "";
		for (let i = 0; i < surLov.length; i++) {
			vSurLov += '<option value="'+ surLov[i].r +'"'+ (surLov[i].r == vSur ? ' selected' : '') +'>'+ surLov[i].d +'</option>';
		}
		vSurLov = '<select name="lciSur" class="apex-item-select" size="1"'+ (vItemType == 'S' ? '' : ' style="display:none;"') +'><option value=""></option>'+ vSurLov +'</select>';
		var vItemTypeLov = '<select name="lciItemType" onchange="vms.logTemp.toggleIType(this);" class="apex-item-select" size="1">'
					  +(logTemplate.type == 'E' ? '<option value="P">Equipment Parameter</option>' : '')
					  +'<option value="N">Number</option>'
					  +'<option value="T">Text Field</option>'
					  +'<option value="C">Comment</option>'
					  +'<option value="INSPECT">Inspection</option>'
					  + (lciLtType == 'M' ? '' : '<option value="CB">Checkbox</option>')//'<option value="A">Author</option>'
					  + (lciLtType == 'O' ? '' : '<option value="S">Checklist</option>')//'<option value="A">Author</option>'
					  + '</select>';
		vItemTypeLov = vItemTypeLov.replace('value="' + vItemType + '"', 'value="' + vItemType + '" selected');
		
		var vParams = '<div class="lciSB"'+ (vItemType == 'P' ? '' : ' style="display:none;"') +'><input name="lciIps" type="hidden" value="' + vIpsId + '" />'
			+  '<input name="lciIpsTxt" type="text" onclick="vms.logTemp.paramSelect(this, event);" value="' + vIpsTxt + '" readonly="true" class="apex-item-text" />'
			+  '<div class="paramSelectBtn fas fawe-hand-pointer" onclick="vms.logTemp.paramSelect(this, event);"></div>'
			+  '<div class="paramSelectBtn last far fawe-times" onclick="vms.logTemp.paramSelectClr(this);"></div>'
			+ '</div>';
//logTemplate.items[i].seq
		vRow = '<tr>'
			+ '<td><div class="lcBtn sort">'
			+  '<div class="far fawe-chevron-up" onclick="vms.logTemp.itemSort(this,\'UP\');"></div>'
			+  '<div class="far fawe-chevron-down" onclick="vms.logTemp.itemSort(this,\'DOWN\');"></div>'
			+ '</div></td>'
			+ '<td class="no">' + vSeq + '</td>'
			+ '<td>'
			+  '<input type="hidden" name="lciId" value="' + vId + '" />'
			+  '<input type="text" name="lciName" class="apex-item-text" value="' + vName + '" />'
			+ '</td><td>'
			+  vItemTypeLov + '</td><td>' 
			+  vUomLov + vParams + vSurLov +'</td><td>' 
			+  '<input type="text" name="lciRNrs" class="apex-item-text" value="'+ vRNrs +'"'+ (vItemType == 'P' || vItemType == 'N' ? '' : ' style="display:none;"') +'></td><td>'
			+  '<div class="lcBtn delete fas fawe-trash-alt" onclick="vms.logTemp.lcDelItem(this);"></div>'
			+ '</td></tr>';
		$(".lciForm > table > tbody").append(vRow);
		
		if (!pData) vms.btn.hightlight("submitChaptersBtn");
	},
	itemSort: function (pThis, pDir){
		var $item = $(pThis).closest('tr');
		if (pDir == 'UP') $item.prev().before($item);
		else if (pDir == 'DOWN') $item.next().after($item);
		vms.btn.hightlight("submitChaptersBtn");
	},
	toggleIType: function (pThis){
		var $vItem = $(pThis);
		if ($vItem.val() == 'P'){ 
			$vItem.closest("tr").find(".lciSB,.lciRNrs").show();
			$vItem.closest("tr").find("select[name=lciUom],select[name=lciSur]").hide();
		} else if ( $vItem.val() == 'S') {
			$vItem.closest("tr").find("select[name=lciSur]").show();
			$vItem.closest("tr").find("select[name=lciUom],.lciSB,.lciRNrs").hide();
		} else {
			$vItem.closest("tr").find(".lciSB").hide().find("input[name=lciIps],input[name=lciIpsTxt]").val("");
			if ($vItem.val() == 'N')
				$vItem.closest("tr").find("select[name=lciUom],input[name=lciRNrs]").show();
			else
				$vItem.closest("tr").find("select[name=lciUom],input[name=lciRNrs],select[name=lciSur]").hide().val("1");
		}
	},
	lcDelItem: function (pThis) {
		if(confirm('Are you sure you want to delete this chapter?')){
			$c = $(pThis).closest("tr");
			chapterItemsDeleteIds.push($c.find("input[name=lciId]").val());
			$c.remove();
			vms.btn.hightlight("submitChaptersBtn");
		}
	},
	submit: function () {
		var vRows = [], vData, vCntM = 0, vMasterId = $v("P93_ID"), vItems;
		vms.page.loading();
		vms.logTemp.chapterItemsApply();
		$(".lcForm .chapter").each(function () {
			if ($(this).hasClass("main")) {
				vCnt = 0;
				vCntM++;
				vRow = $(this).attr("lcid") + '|' + vMasterId + '|'
					+ $(this).find("input[name=name]").val().replace("|", "").replace("~", "") + '|'
					+ vCntM
					+ '|N';
				vRows.push(vRow);
			} else {
				vCnt++;
				vRow = $(this).attr("lcid") + '|'
					+ $(this).closest(".chapter.main").attr("lcid") + '|'
					+ $(this).find("input[name=name]").val().replace("|", "").replace("~", "") + '|'
					+ vCnt + '|'
					+ $(this).attr("ctype");
				vRows.push(vRow);
			}
		});
		vData = vRows.join("~");
		vRows = [];
		for (i = 0; i < logTemplate.items.length; i++) {
			vRows.push( logTemplate.items[i].id + "|" + 
						logTemplate.items[i].lt_id + "|" + 
						logTemplate.items[i].seq + "|" + 
						logTemplate.items[i].name + "|" + 
						logTemplate.items[i].iType + "|" + 
						(typeof logTemplate.items[i].ips_id == "undefined" ? "" : logTemplate.items[i].ips_id) + "|" + 
						(typeof logTemplate.items[i].rNrs == "undefined" ? "" : logTemplate.items[i].rNrs) + "|" + 
						logTemplate.items[i].uom + "|" + 
						(typeof logTemplate.items[i].sur == "undefined" || logTemplate.items[i].sur == null ? "" : logTemplate.items[i].sur) );
		}
		vItems = vRows.join("~");
		apex.server.process("submitTemplate", {
			x01: vData,
			x02: chapterDeleteIds.join(":"),
			x03: vItems,
			x04: chapterItemsDeleteIds.join(":"),
			x05: $v("P93_NAME")
        }, {
            dataType: "json",
            success: function(d) {
				logTemplate = d;
				vms.logTemp.render();
				vms.btn.unhightlight("submitChaptersBtn");
				chapterDeleteIds = [];
				chapterItemsDeleteIds = [];
				$s("P93_WARNING", (d.warning ? d.warning : ""));
				$('#previewLog').hide();
				vms.page.loadingRemove();
				if (vms.logTemp.headerChange) {
					apex.submit("SAVE");
				}
			}
        });
	},
	$c: {},
	paramSet: function (pThis) {
		var vId = $(pThis).attr("sid");
		this.$c.find("input[name=lciIps]").val(vId);
		this.$c.find("input[name=lciIpsTxt]").val($(pThis).find("td.parent").text() +" > "+ $(pThis).find("td.name").prev().text() +" | "+ $(pThis).find("td.name").text());
		$(".paramSelect").dialog("destroy").remove();
		vms.btn.hightlight("submitChaptersBtn");
	},
	paramSelect: function (pThis, pEvent) {
		vSelect = "";
		this.$c = $(pThis).closest(".lciSB");
		pEvent.stopPropagation();
		$(".paramSelect").remove();
		for (i = 0; i < taskParam.length; i++) {
			vSelect += '<tr sid="' + taskParam[i].id + '" onclick="vms.logTemp.paramSet(this);"><td class="parent">'+ taskParam[i].parent +'</td><td>'
				+ taskParam[i].item + '</td><td class="name">' + taskParam[i].param + '</td><td>' + taskParam[i].uom + '</td><td>' + taskParam[i].dec_places + '</td><td>' + taskParam[i].min_val + '</td><td>' + taskParam[i].max_val + '</td><td>' + taskParam[i].cont + '</td></tr>';
		}
		var lSelected = $(pThis).closest(".lciSB").find("input[name=lciIpsTxt],input[name=lciIpsTxt2]").val();
		$(pThis).closest(".lciSB").addClass("open").append('<div class="paramSelect">'
			+ (lSelected == "" ? '' : '<div class="selectedSB">Selected: '+ lSelected +'</div>')
			+ '<input id="paramSearchBox" type="text" onkeyup="vms.logTemp.paramSearch(this);" value="" class="apex-item-text" placeholder="Search" />'
			+ '<table>'
			+ '<thead><tr><th>Parent Category</th><th>Component</th><th>Parameter Name</th><th>Uom</th><th>Decimal Places</th><th>Min. Value</th><th>Max. Value</th><th>Continuous</th></thead>'
			+ '<tbody>' + vSelect + '</tbody>'
			+ '</table></div>');
		$(".paramSelect").dialog({
				modal: true,
				width: 960
			});
		$("#paramSearchBox").focus();
		/*$("html").click(function(event) {
			if ($(event.target).closest('.paramSelect,.paramSelectBtn').length === 0) {
				$('.paramSelect').hide();
			}
		});*/
	},
	paramSelectClr: function (pThis) {
		var $cont = $(pThis).closest(".lciSB");
		$cont.find("input[name=lciIps]").val("");
		$cont.find("input[name=lciIpsTxt]").val("");
		vms.btn.hightlight("submitChaptersBtn");
	},
	paramSearch: function (pThis) {
		var vVal = pThis.value.toLowerCase();
		if (vVal == "") $(".paramSelect > table > tbody > tr.hidden").removeClass("hidden");
		else $(".paramSelect > table > tbody > tr").each(function () {
			if ($(this).text().toLowerCase().indexOf(vVal) >= 0) $(this).removeClass("hidden");
			else $(this).addClass("hidden");
		});
	}
}
/* --- */
/* Log */
/* --- */
var vLog = vLog ||{};
var logMultirows = [];
vms.log = {
	load: function (pLogTempId, pLogId){
		vms.page.loading();
		apex.server.process("loadLog", {
			x01: pLogTempId,
			x02: pLogId
		}, {
			dataType: "json",
			success: function (d){
				vLog = d;
				vms.log.formRender();
				vms.page.loadingRemove();
				$(".vmsLogFreqTab>div[data-id="+pLogId+"]").addClass("active").siblings().removeClass("active");
				//$('html, body').animate({ scrollTop: $("#log").offset().top - 60 }, 'slow');
				var row = -1;
				$( ".vLog td.sub" ).each(function( i ) {
					row = row + $( this ).prop("rowspan");
					$( this ).css('border-left','2px double #ffffff');
					$('.logWatch tbody tr:eq('+row+')').css('border-bottom','2px double #ffffff');
				});
			}
		});
	},
	loadLogs: function (){
		vms.page.loading();
		apex.server.process("loadLogs", {
			x01: $v("P90_LOG_TYPE"),
			x02: $v("P90_DATE")
		}, {
			dataType: "html",
			success: function (d){
				vms.page.loadingRemove();
				$("#log").html("");
				$(".vmsLogFreqTab").replaceWith(d);
			}
		});
	},
	form: function (pLogId) {
		vms.page.loading();
		apex.server.process("logForm", {
            x01: pLogId
        }, {
            dataType: "json",
            success: function(d) {
					vLog = d;
					vms.log.formRender();
					vms.page.loadingRemove();
					if (pLogId == 0) $('#previewLog').show();
					$('html, body').animate({ scrollTop: $("#log").offset().top - 60 }, 'slow');
			}
        });
	},
	formData: function () {
		var lTitle;
		var lItem;
		for (i = 0; i < vLog.data.length; i++) {
			lTitle = (vLog.data[i].updatedOn ? 'Updated on ' + vLog.data[i].updatedOn : '');
			if (vLog.data[i].updatedBy) lTitle += ' by ' + vLog.data[i].updatedBy;
			$lItem = $("#" + vLog.data[i].id);
			if ($lItem.length == 0) continue;
			else if ($lItem[0].type == "checkbox") $lItem.prop( "checked", $lItem[0].value == vLog.data[i].val);
			else if ($lItem.hasClass("radio_group")) {
				$s(vLog.data[i].id, vLog.data[i].val);
				//if (!vLog.edit) apex.item(vLog.data[i].id).disable();
			}
			else $lItem.html(vLog.data[i].val); 
			if (vLog.data[i].red == 'true') {$lItem.closest("td").addClass('redBkgd');} else {$lItem.closest("td").removeClass('redBkgd');}
			// performed on date
			if (vLog.data[i].po) {
				if (vLog.edit) $("#P" + vLog.data[i].id.substring(1) ).val(vLog.data[i].po);
				else $("#P" + vLog.data[i].id.substring(1) ).text(vLog.data[i].po);
			}
			//if (vLog.data[i].updatedBy) $("#U" + vLog.data[i].id.substring(1) ).val(vLog.data[i].updatedBy);
			if (vLog.data[i].updatedBy) {
				let $updElement = $("#U" + vLog.data[i].id.substring(1) );
				if ($updElement[0].nodeName == 'TD') $updElement.html(vLog.data[i].po + " | " + vLog.data[i].updatedBy);
				else $updElement.val(vLog.data[i].po + " | " + vLog.data[i].updatedBy);
			}
			if (vLog.data[i].note) $("#C" + vLog.data[i].id.substring(1) ).text(vLog.data[i].note);
			
			if (lTitle != '') $lItem.attr('title', lTitle);
			// history count
			if ((vLog.data[i].histCnt > 0 || vLog.data[i].reqCnt > 1) && $lItem.hasClass("radio_group")!==true) {
				var vWarn = vLog.data[i].reqCnt > 1 && vLog.data[i].reqCnt > (vLog.data[i].histCnt+1);
				$lItem.parent("td").find('.historyCnt').remove();
				$lItem.parent("td").append('<div class="historyCnt'+ (vWarn ? ' red' : '') +
											'" onclick="vms.log.loadHistory('+ vLog.log_id +','+ vLog.data[i].ltiId +','+ vLog.data[i].seq +',this);">'+ 
											'<i class="fas fa-history"></i> <span>'+
											(vLog.data[i].histCnt+1) +'</span>'+
											(vLog.data[i].reqCnt > 1 ? '/'+ vLog.data[i].reqCnt : '' )+
											'</div>')
			}
		}
		$(window).off('beforeunload');
		$("#log input").change(function (e) { vms.log.change(e.target) });
		$("#log td > div").keyup(function (e) { vms.log.change(e.target) });
	},
	commitTimeout: {},
	change: function (pThis) {
		var vOldVal, vNewVal, vItemType, vId = pThis.id, vExist = false, vMinVal = 0, vMaxVal = 0;
		// get new value
		if (pThis.nodeName == 'DIV') vNewVal = $(pThis).text();
		else if (pThis.type == 'checkbox') vNewVal = pThis.checked ? pThis.value : "";
		else vNewVal = pThis.value;
		
		// check valid range as you type
		if ($(pThis).attr("type") == 'number' && isNaN(vNewVal)==false){
			if (vNewVal != "") {
				vMinVal = Number($(pThis).attr("minval"));
				vMaxVal = Number($(pThis).attr("maxval"));
				if (Number(vNewVal) >= vMinVal && vNewVal <= Number(vNewVal)) $('#'+vId).parent().removeClass('redBkgd');
				else $('#'+vId).parent().addClass('redBkgd');
			}
			else $('#'+vId).parent().removeClass('redBkgd');
		}
		
		// radio button specific item ID
		if (pThis.type == 'radio') vId = pThis.name;
		// check number values
		if ($(pThis).attr("type") == 'number' && isNaN(vNewVal) && vNewVal != ""){
			vNewVal = 0;
			$(pThis).text(vNewVal);
		}
		// fetch old value
		for (i = 0; i < vLog.data.length; i++) {
			//console.log('vLog.data.length='+vLog.data.length);
			if (vLog.data[i].id == vId) {
				vOldVal = vLog.data[i].val;
				break;
			}
		}
		// update value if already in change queue
		for (i = 0; i < vLog.changed.length; i++) {
			if (vLog.changed[i].id == vId) {
				if (vOldVal == vNewVal) vLog.changed.splice(i, 1);
				else if (vNewVal != vLog.changed[i].val) vLog.changed[i].val = vNewVal;
				vExist = true;
				break;
			}
		}
		// push value to change queue
		if (!vExist) vLog.changed.push({ "id": vId, "val": vNewVal});
		// update date performed if new entry
		if (vId.charAt(0) == 'I') {
			var now =  vLog.mon +"/"+ vLog.date +"/"+ vLog.year +" "+ vLog.hour +":"+ vLog.min; 
			//$(pThis).closest("td").next().find("input").val(now).trigger("change");
			$(pThis).closest("tr").find("td.dateContainer input").val(now).trigger("change");
		}
		// highlight save button
		if (vLog.changed.length == 0) vms.btn.unhightlight("saveLog");
		else {
			vms.btn.hightlight("saveLog");
			if (vId.substr(0, 1) == 'M') {
				var $authorDiv = $(pThis).closest("tr").find("div[author=true]");
				if ($authorDiv.length > 0){
					$authorDiv.html(vLog.currentUser);
					vms.log.change($authorDiv[0]);
				}
			}
			clearTimeout(vms.log.commitTimeout);
			vms.log.commitTimeout = setTimeout( ()=>{ vms.log.submit(); }, 10000);
		}
		$(window).on('beforeunload', function() {return "Please save your changes before leaving the page!";});
	},
	submit: function () {
		var vData = [];
		clearTimeout(vms.log.commitTimeout);
		//vms.page.saving();
		for (i = 0; i < vLog.changed.length; i++) {
			vData.push(vLog.changed[i].id + "|" + vLog.changed[i].val.replace("|", "").replace("~", ""));
		}		
		apex.server.process("logFormSubmit", {
            x01: vLog.log_id,
			x02: vData.join("~"),
			f01: vLog.delete
        }, {
            dataType: "json",
            success: function(d) {
				vLog.data = d;
				apex.message.showPageSuccess( "Changes saved!" );
				vms.log.formData();
				// rerender log multirows
				/*for (var i = 0; i < logMultirows.length; i++) {
					logMultirows[i].seq = 0;
					var $mr = $(".logMrChapter[ltid=" + logMultirows[i].id + "]");
					$mr.find("tbody").html("");
					vms.log.mrAddRow($mr.find(".btnContainer > .t-Button"));
				}*/
				//vms.page.savingRemove();
			}
        });
		// could be a problem if ajax fails
		vLog.changed = [];
		vLog.delete = [];
		vms.btn.unhightlight("saveLog");
		$(window).off('beforeunload');
	},
	formRender: function () {
		var vH1, vH2, vH3, vH2_cnt, vH3_cnt, vH1_3_cnt, vColIds, vCols, vTable, vItems = ""/*, hasHours = false*/;
		var $log = $("#log");
		var vTdClass, vList = "";
		// prepare shift thead
		var vShiftThead = '';
		var vShiftTheadD = '';
		if (vLog.shifts) {
			for (x = 0; x < vLog.shifts.length; x++) {
				vShiftThead += '<th' + (vLog.currentWatch == vLog.shifts[x].id ? ' class="light"' : '') + '>' + vLog.shifts[x].name + '</td>';
			}
		} else {
			vLog.shifts.push({ id: 0, name: "No Shifts" });
			vShiftThead += '<th>No Shifts</td>';
		}
		vShiftThead = '<thead><tr><th class="logTitle" colspan="5">#HEADER#</th>' + vShiftThead + '<th>Date Performed</th><th>Comments</th></tr></tr></thead>';
		
		// header for chapters without shifts/per day-colspan="4"
		vShiftTheadD = '<thead><tr><th class="logTitle" colspan="4">#HEADER#</th><th style="width: 22rem;">Input Type</th><th style="width: 22rem; z-index: 2;">Value</th><th>Comment</th><th style="width: 30rem;">Updated</th></tr></thead>';
		// Watch Table
		vH1 = "";
		vTable = "";
		////////////////
		// Multirows //
		var lChapters = '';
		var vMultirows = '';
		logMultirows = [];
		var vColNo = 0;
		for (i = 0; i < vLog.chapters.length; i++) {
			var lChapter = vLog.chapters[i]
			var vTablesMr = '';
			var vTablesShift = '';
			var lWatchItemCnt = 0;
			var lDatepickers = [];
			for (j = 0; j < lChapter.sub.length; j++) {
				var lSubChapter = lChapter.sub[j];
				vTable = '';
				if (lSubChapter.type == 'M') {
					for (k = 0; k < lSubChapter.mr.length; k++) {
						vTable += '<th>' + lSubChapter.mr[k].name + '</th>';
					}
					if (vTable != '') {
						vTablesMr += '<div class="logMrChapter" ltid="' + lSubChapter.id + '">'
							+ (lSubChapter.name == "" ? '' : '<div class="h2">' + lSubChapter.name + '</div>')
							+ '<table><thead><tr>' + vTable
							+ '<th style="width: 25rem;">Updated</th><th style="width: 5rem;"></th></tr></thead><tbody></tbody></table>'
							+ '<div class="btnContainer">'
							+ (vLog.edit ? vms.btn.gen({label:"Add Row", fa: "far fawe-plus", js:"vms.log.mrAddRow(this);"}) : "")
							+ '</div>'
							+ '</div>';
						lSubChapter.seq = 0;
						logMultirows.push(lSubChapter);
					}
				} else {
					itemCnt = 0;
					var vColSpan = lSubChapter.name ? '' : ' colspan="2"';
					for (k = 0; k < lSubChapter.items.length; k++) {
						vColNo++;
						var lItem = lSubChapter.items[k];
						var vHist = (lItem.itemType == 'N' || lItem.itemType == 'P' ? '<div onclick="vms.log.loadHistoryGraph('+ vLog.log_id +','+ lItem.id +',this);"><i class="fas fa-history"></i></div>' : '');
						vTable += '<td class="no">'+vColNo+'</td><td class="hist">'+vHist+'</td>'+
									'<td class="name"' + vColSpan + '>' + lItem.name + '</td>'+
									'<td class="uom">' + lItem.uom + '</td>';
						var vItem;
						if (lItem.itemType == 'C')
							vItem = '<div contenteditable="'+ (vLog.edit ? 'true' : 'false') +'" id="#ID#" class="comment"></div>';
						/*else if (lItem.itemType == 'CB')
							vItem = '<div class="checkbox"><input type="checkbox" id="#ID#" value="OK" /></div>';*/
						else if (lItem.itemType == 'S')
							vItem = '<div class="survey" id="#ID#">'+ lItem.surName +'</div>';
						else if (lItem.itemType == 'INSPECT' || lItem.itemType == 'CB')
							vItem = '<div tabindex="-1" id="#ID#" aria-labelledby="#ID#_LABEL" class="radio_group apex-item-group apex-item-group--rc apex-item-radio" role="group">'+
									' <div class="apex-item-grid radio_group">'+
									'  <div class="apex-item-grid-row">'+
									'   <div class="apex-item-option"><input'+ (vLog.edit ? '':' disabled="disabled"') +' type="radio" id="#ID#_0" name="#ID#" value="G">'
																	+'<label class="u-radio" for="#ID#_0">' + (lItem.itemType == 'CB' ? 'Yes' : 'Good') + '</label></div>'+
									'   <div class="apex-item-option"><input'+ (vLog.edit ? '':' disabled="disabled"') +' type="radio" id="#ID#_1" name="#ID#" value="N">'// checked="checked"
																	+'<label class="u-radio" for="#ID#_1">' + (lItem.itemType == 'CB' ? 'No' : 'Needs Attention') + '</label></div>'+
									'  </div>'+
									' </div>'+
									'</div>';
						/*else if (lItem.itemType == 'DV')
							vItem = '<div contenteditable="'+ (vLog.edit ? 'true' : 'false') +'" id="#ID#" class="dual"></div><span class="dualDivider">/</span>' +
									'<div contenteditable="'+ (vLog.edit ? 'true' : 'false') +'" id="#ID#_2" class="dual"></div>';*/
						else 
							vItem = '<div contenteditable="'+ (vLog.edit ? 'true' : 'false') +'" id="#ID#" class="value"'
									+ (lItem.itemType == 'N' || lItem.itemType == 'P' ? ' type="number" minVal="'+lItem.minVal+'" maxVal="'+lItem.maxVal+'"' : '') +'></div>';
						
						if (lItem.type == 'W') {
							for (x = 0; x < vLog.shifts.length; x++) {
								
								vTable += '<td' + (vLog.currentWatch == vLog.shifts[x].id ? ' class="current"' : '')
									+ '>' + vItem.replace('#ID#', "W_"+ lItem.id + "_" + vLog.shifts[x].id).replace('#ID#', "W_"+ lItem.id + "_" + vLog.shifts[x].id) + '</td>';
							}
							lWatchItemCnt++
						} else {
							vTable += '<td class="logValue'+ ((lItem.itemType == 'INSPECT' || lItem.itemType == 'CB') ? ' t-Form-fieldContainer--radioButtonGroup' : '') 
									+'">'+ vItem.replaceAll('#ID#', 'I_' + lItem.id) +'</td>'
									+'<td><div contenteditable="'+ (vLog.edit ? 'true' : 'false') +'" id="C_' + lItem.id +'" class="comment note"></div></td>'
									+'<td><input type="text" disabled class="apex-item-text" id="U_'+ lItem.id + '" value="" /></td>'
									+'<!--td class="dateContainer">'
									+ (vLog.edit ? '<span style="white-space: nowrap;">'
													+'<input type="text" class="chklDate datepicker apex-item-text apex-item-datepicker" id="P_' + lItem.id +'" maxlength="2000" size="15" value="" autocomplete="off">'
													+'</span>' : 
													'<div id="P_' + lItem.id +'" class="comment"></div>')
									+'</td-->';
							lDatepickers.push('P_' + lItem.id);
						}
						vTable += '</tr>';
						itemCnt++;
					}
					if (itemCnt > 0) {
						vTable = (lSubChapter.name ? '<tr><td rowspan="' + itemCnt + '" class="sub" id="CH'+ lSubChapter.id +'">' + lSubChapter.name + '</td>' : '<tr>')
							+ vTable;
						lChapters += '<a href="#CH'+ lSubChapter.id +'">'+ lSubChapter.name +'</a>';
						vTablesShift += vTable;
					}
				}
			}
			if (vTablesMr != '' || vTablesShift != '') {
				var tableHeader = (lWatchItemCnt > 0 ? vShiftThead : vShiftTheadD);
				tableHeader = tableHeader.replace("#HEADER#", (lChapter.name ? '' + lChapter.name : ''));
				if (vTablesShift != '') vTablesShift = '<div class="logWatch"><table style="position: relative; border-collapse: collapse;">' + tableHeader + '<tbody>' + vTablesShift + '</tbody></table></div>';
				vMultirows += '<div class="logItemChapter"><!--div class="h1">' + (lChapter.name ? '' + lChapter.name : '') + '</div--><div class="cont">'
					+ vTablesShift + vTablesMr + '</div></div>';
			}
		}
		$log.html('<div class="chapterLinks">'+ lChapters + '<a href="#CH_SIG">Sign</a>'+'</div>'+ 
					vMultirows + '<div class="logItemChapter"><div class="cont">'+'<div class="logWatch">'+
									'<table style="position: relative; border-collapse: collapse;">'+
									 '<tbody><tr style="border: 2px double rgb(255, 255, 255);">'+
									 '<td id="CH_SIG" class="name">'+vLog.signedTxt+'</td>'+
									 '<td class="signValue">'+ (vLog.signed ? vLog.signedBy +' @ '+ vLog.signedOn + (vLog.signRemove ? " "+ vms.btn.gen({"id":"signLog","label":"Remove Signature","fa":"fas fawe-signature","js":"vms.log.logSignRemove();"}) : "") : 
									 										 (vLog.canSign ? vms.btn.gen({"id":"signLog","label":"Sign Off","fa":"fas fawe-signature","js":"vms.log.sign();"}) : '') ) +'</td>'+
									 '</tr></tbody>'+
									 '</table></div></div></div>');
		vms.log.formData();
		for (var i = 0; i < logMultirows.length; i++) {
			var mr = logMultirows[i];
			vms.log.mrAddRow($(".logMrChapter[ltid=" + mr.id + "] table"));//>.btnContainer > .t-Button
		}
		if (vLog.edit) {
			for (var i = 0; i < lDatepickers.length; i++) {
				apex.widget.datepicker("#"+lDatepickers[i],{
										"buttonImageOnly":false,
										"buttonText":"\u003Cspan class=\u0022a-Icon icon-calendar\u0022\u003E\u003C\u002Fspan\u003E\u003Cspan class=\u0022u-VisuallyHidden\u0022\u003EPopup Calendar: \u003Cspan\u003E",
										"showTime":true,
										"time24h":true,
										"timeFormat":"HH:ii",
										"defHour":vLog.hour,
										"defMinute":vLog.min,
										"defaultDate":new Date(vLog.year, (vLog.mon-1), vLog.date),
										"showOn":"button",
										"showOtherMonths":false,
										"changeMonth":false,
										"changeYear":false},
										vLog.dateFormat,//"mm\u002Fdd\u002Fyy HH:ii",
										"en"); 
				apex.jQuery("#"+lDatepickers[i]).next('button').addClass('a-Button a-Button--calendar');
			}
		}
	},
	mrAddRow: function (pThis) {
		var $div = $(pThis).closest(".logMrChapter");
		var ltID = $div.attr("ltid");
		var rowHtml = '';
		var hasData = false;
		for (var i = 0; i < logMultirows.length; i++) {
			if (logMultirows[i].id == ltID) {
				logMultirows[i].seq++;
				var vLastUpdateOn = null, vLastUpdateBy = null;
				for (let j = 0; j < logMultirows[i].mr.length; j++) {
					var col = logMultirows[i].mr[j];
					var dataId = (col.itemType == 'A' ? 'A_' : 'M_') + col.id + '_' + logMultirows[i].seq;
					var lVal = '';
					var lTitle = '';
					for (let k = 0; k < vLog.data.length; k++) {
						if (vLog.data[k].id == dataId) {
							lVal = vLog.data[k].val;
							//lTitle = (vLog.data[k].updatedOn ? 'Updated on ' + vLog.data[k].updatedOn : '');
							//if (col.itemType != 'A' && vLog.data[k].updatedBy) lTitle += ' by ' + vLog.data[k].updatedBy;
							vLastUpdateOn = vLog.data[k].updatedOn;// TODO set higher date
							vLastUpdateBy = vLog.data[k].updatedBy;
							hasData = true;
							break;
						}
					}
					rowHtml += '<td><div' + (col.itemType == 'A' ? ' author="true"' : (vLog.edit ? ' contenteditable="true"' :''))
						//+ (lTitle != '' ? ' title="' + lTitle + '"' : '')
						+ ' id="' + dataId + '"'
						+ (col.itemType == 'C' ? ' class="comment"' : '') + '>'
						+ (lVal ? lVal : '') + '</div></td>'
						+ '<td id="U' + dataId.substring(1) +'">'+ (vLastUpdateOn ? vLastUpdateOn +' | '+ vLastUpdateBy : '') +'</td>';
				}
				rowHtml = '<tr>' + rowHtml + '<td>'+ (vLog.edit ? '<a href="javascript:void(0)" onclick="vms.log.mrDeleteRow(this);" class="deleteRow fas fawe-trash-alt"></a>' : '')
						+ '</td></tr>';
				if (hasData || vLog.edit)
					$div.find('tbody').append(rowHtml).find("tr:last-child td > div").keyup(function (e) { vms.log.change(e.target) });
				break;
			}
		}
		if (hasData) vms.log.mrAddRow(pThis);
	},
	mrDeleteRow: function (pThis) {
		var $row = $(pThis).closest('tr');
		$row.find("td > div").each(function () {
			vLog.delete.push(this.id);
		});
		$row.remove();
		vms.btn.hightlight("saveLog");
		clearTimeout(vms.log.commitTimeout);
		vms.log.commitTimeout = setTimeout( ()=>{ vms.log.submit(); }, 10000);
	},
	sign: (pSubmit) => {
		if (pSubmit){
			var vSigPassword = $v("chklSigPass");
			vms.load.add(null, true);
			apex.server.process("logSign"
				, { x01: vLog.log_id, x02: vSigPassword }
				, {
					dataType: "json",
					success: function (d) {
						vms.load.remove();
						if (d.ok) {
							// close dialog
							$("#formChecklistSign").dialog("close");
							// set log data
							vLog.signed = true;
							vLog.signedBy = d.signedBy;
							vLog.signedOn = d.signedOn;
							vLog.signedTxt = d.signedTxt;
							vLog.edit = false;
							// refresh log
							vms.log.formRender();
						} else alert(d.err);
					}
				});
		} else {
			$('<div id="formChecklistSign">'+
				'<div class="col col-12 apex-col-auto dialogContendBody">'+ vms.item.gen({type:"P",id:"chklSigPass",label:"Enter password/pin",def:null, widthPct:"100"}) +'</div>'+
				'<div class="col col-12 apex-col-auto dialogButtonContainer">'+ vms.btn.gen({"label":"Sign","js":"vms.log.sign(true);", fa: 'fas fawe-signature'}) +'</div>'+
			  '</div>').dialog({ title: 'Sign with password', 
								close: function(event, ui) { $(this).dialog('close').remove(); } 
							});
				$("#chklSigPass")[0].addEventListener("keyup", function(event) {
								if (event.keyCode === 13) {
								  event.preventDefault();
								  // Submit pass
								  vms.log.sign(true);
								}
							  });
		}
	},
	logSignRemove: () => {
		vms.load.add(null, true);
		apex.server.process("logSignRemove"
			, { x01: vLog.log_id }
			, {
				dataType: "json",
				success: function (d) {
					vms.load.remove();
					if (d.ok) {
						// set log data
						vLog.signed = false;
						vLog.signedBy = null;
						vLog.signedOn = null;
						vLog.signedTxt = 'Not signed yet';
						vLog.edit = true;
						// refresh log
						vms.log.formRender();
					} else alert(d.err);
				}
			});
	},
	historyCount: null,
	renderHistory: function (pData, pThis){
		console.log(pData);
		vms.log.historyCount = pThis;
		var vRows = "";
		for (i = 0; i < pData.length; i++) {
			vRows += '<tr class="historyRow'+ (pData[i].deleted ? ' deleted' : '') +'"><td>'+ pData[i].val +
					 '</td><td>'+ pData[i].po +
					 '</td><td>'+ pData[i].updatedBy +
					 '</td><td>'+ pData[i].updatedOn +
					 '</td><td>'+ pData[i].note +
					 '</td><td>'+ (pData[i].deleted ? 	'Deleted<br />'+ pData[i].deletedOn + '<br />'+ pData[i].deletedBy : 
					 									(i == 0 ? '' : '<i class="fas fawe-trash" onclick="vms.log.deleteHistory('+ pData[i].id +', this);"></i>'))
					 '</td></tr>';
		}
		$(".historyTable").remove();
		$(pThis).append('<div class="historyTable"><table><thead><tr>'+
						'<th>Value</th>'+
						'<th>Date Performed</th>'+
						'<th>Updated by</th>'+
						'<th>Updated on</th>'+
						'<th>Comments</th>'+
						'<th></th>'+
						'</tr></thead><tbody>' + 
						vRows +'</tbody></table></div>');
		$(".historyTable").dialog({width: 'auto'});
	},
	loadHistory: function (pLogId, pLtiId, pSeq, pThis){
		vms.page.loading();
		apex.server.process("logDataHistory", {
			x01: pLogId,
			x02: pLtiId,
			x03: pSeq
		}, {
			dataType: "json",
			success: function (d){
				vms.page.loadingRemove();
				vms.log.renderHistory(d.rows, pThis);
			}
		});
	},
	deleteHistory: function (pLDId, pThis){
		vms.page.loading();
		apex.server.process("logDataDelete", {
			x01: pLDId
		}, {
			dataType: "json",
			success: function (d){
				vms.page.loadingRemove();
				var $cntEl = $(vms.log.historyCount).find('>span');
				var cnt = parseInt($cntEl.text());
				$cntEl.text(cnt-1);
				vms.log.renderHistory(d.rows, vms.log.historyCount);
			}
		});
	},
	loadHistoryGraph: function (pLogId, pLtiId, pSeq, pThis){
		vms.page.loading();
		apex.server.process("loadHistoryGraph", {
			x01: pLogId,
			x02: pLtiId
		}, {
			dataType: "html",
			success: function (d){
				vms.page.loadingRemove();
				eval(d);
			}
		});
	}
};